<template>
    <el-form
        ref="password"
        :model="addform"
        label-width="120px"
    >
        <el-form-item label="旧密码:">
            <el-input
                v-model="addform.oldpw"
                style="width: 240px"
                show-password
            />
        </el-form-item>
        <el-form-item label="新密码:">
            <el-input
                v-model="addform.newpw"
                style="width: 240px"
                show-password
            />
        </el-form-item>
        <el-form-item label="再输入一次:">
            <el-input
                v-model="addform.newpwr"
                style="width: 240px"
                show-password
            />
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="onSubmit()">提交</el-button>
            <el-button @click="close()">取消</el-button>
        </el-form-item>
    </el-form>
</template>

<script>

export default {
    props: {},
    data() {
        return {
            addform: {
                oldpw: "",
                newpw: "",
                newpwr: "",
            },
        };
    },
    mounted() {},
    methods: {
        close() {
            this.$emit("close");
        },
        onSubmit() {
            let _this = this;
            let data = {
                oldpass: this.addform.oldpw,
                newpass: this.addform.newpw,
            };
            if (this.addform.newpw != this.addform.newpwr) {
                this.$common.error("两次密码不同");
                return;
            }
            let pattern = /^[a-zA-Z0-9]{9,30}$/;
            let ss = pattern.test(this.addform.newpw);
            if(!ss){
                this.$common.error("只能为9到30位大小写字母数字组成");
                return;
            }
            this.$api.updatePass(data).then((res) => {
                if (res.data.code == 1) {
                    this.$common.success("修改成功");
                    _this.addform = {
                        oldpw: "",
                        newpw: "",
                        newpwr: "",
                    };
                    this.$emit("close");
                } else {
                    this.$common.success(res.data.msg);
                }
            });
        },
    },
};
</script>
